var map = {
	"./custom-software-solutions copy.svg": 12340,
	"./custom-software-solutions.svg": 74491,
	"./dedicated-dev-team copy.svg": 90611,
	"./dedicated-dev-team.svg": 55940,
	"./strategic-consulting copy.svg": 31338,
	"./strategic-consulting.svg": 20223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1002;